module.exports = __webpack_public_path__ + "static/media/echeq__emit-massive-icon.5f5f8a9d.svg";